import React, { useEffect, useRef } from "react";

const ConfirmDialog = ({ isOpen, title = 'Bekräfta redigering', message = 'Är du säker?', onConfirm, onCancel }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen) {
      if (!dialog.open) {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }
    } else {
      if (dialog.open) {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <dialog ref={dialogRef} className="confirm-dialog" open={isOpen}>
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="dialog-buttons flex flex-align-center-v">
        <button className="dialog-button" onClick={onConfirm}>Ja</button>
        <button className="dialog-button" onClick={onCancel}>Nej</button>
      </div>
    </dialog>
  );
};

export default ConfirmDialog;
export { ConfirmDialog };
